import { Alignment, Displaying, Typography } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { memo } from "react";
import { EXTERNAL_PATH_COLLECTION } from "../../../../../constants/env";
import type { ChatbotWarningMessageProps } from "./chatbot-warning-message.interface";

export const CHATBOT_WARNING_MESSAGE_ID = "chatbot-warning-message";

function ChatbotWarningMessage({ chatbotName }: Readonly<ChatbotWarningMessageProps>): JSX.Element {
  return (
    <Box id={CHATBOT_WARNING_MESSAGE_ID} display={Displaying.flex} justifyContent={Alignment.center}>
      <Typography variant="caption" color="textSecondary" textAlign={Alignment.center}>
        {chatbotName} può commettere errori, controlla i{" "}
        <Link href={EXTERNAL_PATH_COLLECTION.get("terms_of_use")} target="_blank" color={"textSecondary"}>
          Termini di utilizzo
        </Link>{" "}
        e{" "}
        <Link href={EXTERNAL_PATH_COLLECTION.get("ai_privacy_policy")} target="_blank" color={"textSecondary"}>
          l&apos;informativa privacy
        </Link>
        .
      </Typography>
    </Box>
  );
}

export default memo(ChatbotWarningMessage);
